module.exports = __webpack_public_path__ + "static/media/columbia95.586c9dca.png";